import fila from './fila'
import parametrizacao from './parametrizacao'
import relatorioSolicitacao from './relatorioSolicitacao'
import solicitacao from './solicitacao'
import status from './status'
import monitoramentoProtocolo from './monitoramentoProtocolo'
import reagendamentoMedico from './reagendamentoMedico'

export default [
    {
        path: 'regulacao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...fila,
            ...parametrizacao,
            ...relatorioSolicitacao,
            ...solicitacao,
            ...status,
            ...monitoramentoProtocolo,
            ...reagendamentoMedico,
        ]
    }
]
